import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// interface LegalOption {
//   id: string;
//   title: string;
//   description: string;
//   icon: React.ReactNode;
//   route: string;
// }

// const legalOptions: LegalOption[] = [
//   {
//     id: "personal-injury",
//     title: "Personal Injury",
//     description:
//       "Car accidents, medical malpractice, workplace injuries, and more",
//     icon: <PersonalInjuryIcon />,
//     route: "/personal-injury",
//   },
//   {
//     id: "business-consultation",
//     title: "Business Consultation",
//     description:
//       "Business disputes, contracts, corporate law, and commercial matters",
//     icon: <BusinessIcon />,
//     route: "/business-consultation",
//   },
//   {
//     id: "other-legal",
//     title: "Other Legal Area",
//     description:
//       "Family law, criminal defense, immigration, real estate, and other areas",
//     icon: <OtherLegalIcon />,
//     route: "/not-available",
//   },
// ];

export function LegalAreaSelection() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/independent-attorneys");
  }, []);

  return (
    <div className=" overflow-y-auto p-4 bg-white">
      Dear user, <br />
      we are unable to identify your current requirements. please answer the
      questions as mentioned in the following message.
      <br />
      <br />
      Once you have provided the necessary information, tag @inhouse seeking
      legal assistance, and we will promptly connect you with a qualified
      attorney who can help address your needs.
    </div>
  );
}
